import { Activities } from "../_models/activities";
import axios from 'axios'
import { bus } from '../main'

export const activityService = {
    getInstituteActivityState,
    editInstituteActivityState,
    getActivityState,
    getSubscriptions,
    getAttivitaIstitutiInteresseAzienda,
    subscribeToActivityAzienda,
    getAttivitaIstitutoAllievo,
    subscribeToActivityAllievo,
    addWorkshopPreference,
    addColloquioPreference
}

// const headUrl = "http://localhost:8181/RestApi/valtis/valtis"
// const siteUrl = "http://localhost:8080"

const headUrl = "https://valtis.infosys.it/RestApi/valtis/valtis"
const siteUrl = "https://valtis.infosys.it"

function getInstituteActivityState(idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/InstituteActivityState", {
        params: {
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getActivityState(idAzienda: number) {
    //da terminare 
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/ActivityState", {
        params: {
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function editInstituteActivityState(activitiesState: Activities) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/EditInstituteActivityState", {
        params: {
            activities: activitiesState
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getSubscriptions(idAzienda: number, idAnnoScolastico: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetSubscriptions", {
        params: {
            idAzienda: idAzienda,
            // idIstituto: idIstituto,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

//metodi gestione attivita v2.0 --------------------------------------------------------------

function getAttivitaIstitutiInteresseAzienda(idAzienda: number, idAnnoScolastico: number, activityType: string) {
    var token: string | null = localStorage.getItem('userToken')
    var idActivityType: number = 0;
    if (activityType === 'tirocinioEstivo') {
        idActivityType = 1
    } else if (activityType === 'alternanza') {
        idActivityType = 2
    }else if (activityType === 'tirocinioFormativo') {
        idActivityType = 4
    } else if (activityType === 'workshop') {
        idActivityType = 5
    } else if(activityType === 'colloqui'){
        idActivityType = 3
    }
    return axios.get(headUrl + "/GetAttivitaIstitutiInteresseAzienda", {
        params: {
            idAzienda: idAzienda,
            idActivityType: idActivityType,
            idAnnoScolastico: idAnnoScolastico
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function subscribeToActivityAzienda(idAttivita: number, idAzienda: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SubscribeToActivityAzienda", {
        params: {
            idAttivita: idAttivita,
            idAzienda: idAzienda
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function getAttivitaIstitutoAllievo(idAllievo: number, idAnnoScolastico: number, idIstituto: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.get(headUrl + "/GetAttivitaIstitutoAllievo", {
        params: {
            idAllievo: idAllievo,
            idAnnoScolastico: idAnnoScolastico,
            idIstituto: idIstituto
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function subscribeToActivityAllievo(idAttivita: number, idAllievo: number) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/SubscribeToActivityAllievo", {
        params: {
            idAttivita: idAttivita,
            idAllievo: idAllievo
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function addWorkshopPreference(idAzienda: number, idIscrizione: number, scelta: any, referente: any) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AddWorkshopPreference", {
        params: {
            idAzienda: idAzienda,
            idIscrizione: idIscrizione,
            scelta: scelta,
            referente: referente
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}

function addColloquioPreference(idAzienda: number, idIscrizione: number, scelta: any) {
    var token: string | null = localStorage.getItem('userToken')
    return axios.post(headUrl + "/AddColloquioPreference", {
        params: {
            idAzienda: idAzienda,
            idIscrizione: idIscrizione,
            scelta: scelta
        },
        headers: {
            Authorization: 'Bearer ' + token
        }
    }).then(response => {
        return response.data
    }).catch(error => {
        bus.$emit('errorOperation', error.response.statusText);
        throw error;
    })
}